import React from "react";
import { motion } from "framer-motion";

const Highlight = ({ children }) => {
  return (
    <motion.span
      className="highlight-text"
      initial={{ opacity: 0.4 }}
      whileInView={{
        opacity: 1,
        textShadow: "0 0 10px rgba(244,180,0,0.9)",
        scale: 1.05,
      }}
      transition={{ duration: 0.5 }}
      viewport={{ once: false, amount: 0.8 }}
    >
      {children}
    </motion.span>
  );
};

export default Highlight;